var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5748 1.9671C12.2683 1.6605 11.9045 1.41728 11.504 1.25135C11.1035 1.08541 10.6743 1 10.2408 1C9.80728 1 9.37804 1.08541 8.97756 1.25135C8.57709 1.41728 8.21323 1.6605 7.90678 1.9671L7.27077 2.6031L6.63477 1.9671C6.01576 1.34808 5.17619 1.00032 4.30077 1.00032C3.42535 1.00032 2.58579 1.34808 1.96677 1.9671C1.34776 2.58611 1 3.42568 1 4.3011C1 5.17652 1.34776 6.01608 1.96677 6.6351L7.27077 11.9391L12.5748 6.6351C12.8814 6.32864 13.1246 5.96478 13.2905 5.56431C13.4565 5.16383 13.5419 4.73459 13.5419 4.3011C13.5419 3.8676 13.4565 3.43836 13.2905 3.03788C13.1246 2.63741 12.8814 2.27355 12.5748 1.9671Z",
    fill: "#FFB800",
    stroke: "#FFB800",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeon);
export default __webpack_public_path__ + "static/media/like=on.702dab1e2c4d7d89d42c91d427ec7007.svg";
export { ForwardRef as ReactComponent };